export const LAST_ACTIVE_PROCESS_STATEMENT = 'LAST_ACTIVE_PROCESS_STATEMENT';

export const lastActiveProcessStatement = ({ id }) => ({
    type: LAST_ACTIVE_PROCESS_STATEMENT,
    payload: {
        id
    }
});
